export const rootStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 16px',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const titleGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
};
